import {controller, target, targets} from '@github/catalyst'

@controller
export default class PrivateForksGitCloneHelpElement extends HTMLElement {
  @target declare helpField: HTMLInputElement
  @targets declare helpTexts: HTMLElement[]
  @targets declare cloneURLButtons: HTMLElement[]
  @target declare cloneCommandPrefix: HTMLElement

  connectedCallback() {
    const buttonToTarget = this.cloneURLButtons[0]
    // Make sure that the data is up to date on first page load
    if (buttonToTarget) {
      this.updateSelectedCloneMethod(buttonToTarget)
    }
  }

  updateURL(event: Event) {
    const switcher = event.currentTarget as HTMLElement
    this.updateSelectedCloneMethod(switcher)
  }

  updateSelectedCloneMethod(switcher: HTMLElement) {
    const url = switcher.getAttribute('data-url') || ''

    this.helpField.value = url

    if (switcher.matches('.js-git-protocol-clone-url')) {
      for (const el of this.helpTexts) {
        this.cloneCommandPrefix.textContent =
          switcher.getAttribute('data-protocol') === 'GitHub CLI' ? '' : 'git clone '

        el.textContent = url
      }
    }

    for (const button of this.cloneURLButtons) {
      button.classList.remove('selected')
    }
    switcher.classList.add('selected')
  }
}
